<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <tabs
        ref="tabs"
        :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
        class="spl-edit-tabs"
        @changed="onTabChanged">
        <tab id="general" name="General">
          <export-proof-edit-general />
        </tab>
        <tab id="columns" name="Columns">
          <export-proof-edit-columns />
        </tab>
        <tab id="defaultFilter" name="Default Filter">
          <export-proof-edit-default-filter />
        </tab>
      </tabs>
      <export-proof-edit-action-bar
        :active-tab="activeTab"
        @onNext="handleNext"
        @onCancel="handleCancel" />
      <div v-if="isLoading" class="spl-load-img" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { mapState, mapMutations, mapActions } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import { cloneDeep } from 'lodash'
import store from '@/store'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      activeTab: 'general',
      tabs: ['general', 'columns', 'defaultFilter']
    }
  },
  computed: {
    ...mapState('exportProof', ['loadedExportProof', 'currentEditExportProof'])
  },
  beforeRouteEnter (to, from, next) {
    // load the export proof before proceding when we enter an edit route
    if (to.name === 'export-proof-edit') {
      store.dispatch('exportProof/loadExportProof', to.params.id).then(() => {
        next()
      }).catch((error) => {
        next()
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    } else {
      next()
    }
  },
  created () {
    if (this.$route.name === 'export-proof-create') {
      // Set a default export proof when creating a new one
      this.setCurrentEditExportProof({
        Export_Proof_Name: '',
        Export_Proof_Filter: {},
        Export_Proof_Layout: [],
        Date_Range_From: -1,
        Date_Range_To: -1,
        Last_Weeks: -1,
        Last_Months: -1,
        Last_Years: -1
      })
    } else {
      this.setCurrentEditExportProof(cloneDeep(this.loadedExportProof))
    }
  },
  methods: {
    ...mapMutations('exportProof', ['setCurrentEditExportProof']),
    ...mapActions('exportProof', ['saveExportProof', 'loadExportProof']),

    // ************************ Show Login is set to true if teh user is not logged in or if the token has expired.
    validateAndSend () {
      // Validate the export proof before sending it
      var valid = true
      var validationMessage =''
      if (this.exportProofNameMissing()) {
        valid = false
        validationMessage = 'Please enter the Export Proof Name.'
      } else if (this.colmunsMissing) {
        valid = false
        validationMessage = 'Please choose at least one column.'
      } else if (this.dateRangesMissing()) {
        valid = false
        validationMessage = 'Please choose a valid date range (only values  greater than zero are allowed).'
      } else if (this.dateFromAfterDateTo()) {
        valid = false
        validationMessage = "Please choose a valid date range where 'From' is before 'To'."
      } else if (this.exportProofCustomerMissing()) {
        valid = false
        validationMessage = 'Please select the Customer.'
      } else if (this.exportProofCountryMissing()) {
        valid = false
        validationMessage = 'Please select the Country.'
      } else if (this.weightColumnMissing()) {
        valid = false
        validationMessage = 'Please include Weight column.'
      }

      if (valid) {
        this.isLoading = true
        // saving the  export proof to the database
        this.saveExportProof(this.currentEditExportProof).then((response) => {
          this.isLoading = false
          this.$router.push('/export-proof-detail/' + response.data)
        }).catch((error) => {
          this.isLoading = false
          messageDialog('Something went wrong: ' + error.ExceptionMessage)
        })
      } else {
        messageDialog(validationMessage)
      }
    },
    exportProofNameMissing () {
      if (!this.currentEditExportProof.Export_Proof_Name || this.currentEditExportProof.Export_Proof_Name === '') {
        return true
      }
      return false
    },
    exportProofCustomerMissing () {
      if (!this.currentEditExportProof.Export_Proof_Filter.Customers || this.currentEditExportProof.Export_Proof_Filter.Customers.length === 0) {
        return true
      }
      return false
    },
    exportProofCountryMissing () {
      if (!this.currentEditExportProof.Export_Proof_Filter.Countries || this.currentEditExportProof.Export_Proof_Filter.Countries.length === 0) {
        return true
      }
      return false
    },
    weightColumnMissing () {
      var exportProofLayout = this.currentEditExportProof.Export_Proof_Layout
      for (var i = 0; i < exportProofLayout.length; i++) {
        if (exportProofLayout[i].Name === 'Weight') {
          return false
        }
      }
      return true
    },
    columnsMissing () {
      if (!this.currentEditExportProof.Export_Proof_Layout || this.currentEditExportProof.Export_Proof_Layout.length === 0) {
        return true
      }
      return false
    },
    dateRangesMissing () {
      if (this.currentEditExportProof.Last_Weeks <= 0 &&
              this.currentEditExportProof.Last_Months <= 0 &&
              this.currentEditExportProof.Last_Years <= 0 &&
              (this.currentEditExportProof.Date_Range_From < 0 ||
                  this.currentEditExportProof.Date_Range_To < 0)) {
        return true
      }
      return false
    },
    dateFromAfterDateTo () {
      if (this.currentEditExportProof.Date_Range_From < this.currentEditExportProof.Date_Range_To) {
        return true
      }
      return false
    },
    onTabChanged (value) {
      this.activeTab = value.tab.id
    },
    // *********************** Handle Actionbar *************************
    handleNext () {
      // Tab handling
      if (this.activeTab === 'general') {
        this.$refs.tabs.selectTab('#columns')
      } else if (this.activeTab === 'columns') {
        this.$refs.tabs.selectTab('#defaultFilter')
      } else if (this.activeTab === 'defaultFilter') {
        this.validateAndSend()
      }
    },
    handleCancel () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-edit-tabs {
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
</style>
